import styled from 'styled-components'
import { VirtualPage } from '../VirtualPage'

export const StyledVirtualPage = styled(VirtualPage)`
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  flex-direction: column;
`
